import { Component, Input, OnInit } from '@angular/core';
import { environment as params, environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { GtmService } from 'src/app/core/services/utilities/gtm.service';

@Component({
  selector: 'app-nav-widget',
  templateUrl: './nav-widget.component.html',
  styleUrls: ['./nav-widget.component.scss'],
})
export class NavWidgetComponent implements OnInit {
  urlBase: any = (<any>params).api.s3;
  @Input() public isMobile: boolean;
  @Input() public widgetData: any;
  @Input() public route: string;
  constructor(
    private router: Router,
    private _gtm: GtmService,
  ) {
  }

  ngOnInit() {
  }

  changeForm(value) {
    this.sendEvent(value);
    // this.showForm = value;
    this.router.navigate([value]);
  }
  sendEvent(event) {
    //// PRUEBAS
    this._gtm.sendEvent(event);
  }
}
